import { useEffect } from 'react';
import { useNavigate, type NavigateFunction } from 'react-router-dom';

// Exposes react-router's navigate() to non-React callers (singleton listeners,
// the WS socket module, etc.) without dropping back to a full reload. The
// <NavigatorBridge /> component inside the Router context registers the live
// navigate() on mount; callers use navigateGlobal() instead of touching
// window.location.

let navigator: NavigateFunction | null = null;

export const NavigatorBridge: React.FC = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigator = navigate;
    return () => {
      if (navigator === navigate) navigator = null;
    };
  }, [navigate]);
  return null;
};

export function navigateGlobal(path: string): void {
  if (navigator) {
    navigator(path);
    return;
  }
  // Pre-mount fallback. In practice the bridge mounts before any non-React
  // caller runs (it's inside RootNavigation), so this only fires if something
  // calls navigateGlobal during SSR / before the Router is up.
  window.location.assign(path);
}
